import { render, staticRenderFns } from "./VacationEdit.vue?vue&type=template&id=4c4b3145"
import script from "./VacationEdit.vue?vue&type=script&lang=js"
export * from "./VacationEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports